<script setup lang="ts">
import type { TextSize } from '@ui/types/base/text-size'

const props = withDefaults(
  defineProps<{
    size?: TextSize
    tag?: 'label' | 'div'
  }>(),
  {
    size: 'md',
    tag: 'label'
  }
)

const { tag, size } = toRefs(props)

const elementType = computed(() => (tag.value === 'label' ? 'label' : 'div'))
</script>

<template>
  <component
    :is="elementType"
    :class="['leading-none', useTailwindClasses([useTextSize(size)])]"
  >
    <slot />
  </component>
</template>
